import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import  {Printer}  from "../app/Printer";
import { Products } from "../app/acount/ProductModel"
import { Users } from "@/app/acount/AcountModel";


type LcgContextType = {
  socket : WebSocket | null;
  printer : Printer | null;
  products : Products | null;
  users : Users | null;
};

export const LcgContext = createContext<LcgContextType>({} as LcgContextType) ;

export const useLcgContext = () => {
  console.log("Context - connecting client")
  return useContext(LcgContext)
};

export const LcgContextProvider: React. FC<{ children: React. ReactNode }> = ({ children }) => {

const ProviderRef = useRef<LcgContextType> ({} as LcgContextType);

const pr = new Printer();
ProviderRef.current.printer = pr;

const prod = new Products();
prod.Load()
ProviderRef.current.products = prod;

const acounts = new Users();
acounts.Load()
ProviderRef.current.users = acounts;


useEffect(() => {

  const ws = new WebSocket("wss://luckyhogym.cz/api/socket/Dashboard");

  ProviderRef.current.socket = ws

  ws.onopen  = () => console.log("Context - WS - Connected");
  ws.onclose = () => console.log("Context - WS - Disconnected");

  return () => {
    ws.close();
  };
  }, []);
return (
  <LcgContext.Provider value={ProviderRef.current}>
    {children}
  </LcgContext.Provider>
  ) ;
};